const local = {
  OIDC_AUTHORITY: "https://external-sso.ppd.wiley.com/auth/realms/wiley",
  OIDC_CLIENT_ID: "bcf56996-2033-4fc4-89dd-0fcaea2f4c5f",
  OIDC_CLIENT_SECRET: "ca300b68-a02a-4091-aa9c-5d495ad7f158",
  ALM_BASE_URL: "https://account.ppd.wiley.com",
  QAP_API_URL: "https://qa.qap.wiley.host/qa",
  BYPASS_OIDC: false,
  DOMAIN: "localhost",
  ENVIRONMENT: 'LOCAL',
  EQAT_REDIRECTION_URL: 'eqat://https@qap-qa.wiley.com',
  EQAT_LAUNCH_URL: 'eqat://https@qa.qap.wiley.host/qa',
  // AWS AppConfig
  APP_CONFIG_ENABLED: true,
};

export default local;
